export default "__VITE_ASSET__CZPVwyXP__"